<script setup lang="ts">
import i18n from '@/lang/i18n';
import { computed, onMounted } from 'vue';

const emits = defineEmits(['update:modelValue', 'changeSortType', 'close', 'setSelect', 'search', 'setIsAllSelected'])
const props = withDefaults(
  defineProps<{
    width: number | null
    windowKey: string
    sortKey: string
    sortType: string
    items: any[]
    modelValue: {[key: string]: boolean}
    candidateLabel: string
    isSortable: boolean
  }>(),
  {
    width: 100,
    windowKey: '',
    sortKey: '',
    sortType: '',
    isSortable: true
  }
)

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

const sortItemColor = computed(() => (type: string) => {
  return props.sortKey == props.windowKey && props.sortType == type ? '#15829C' : '';
})

const isAllSelected = computed(() => {
  return Object.values(modelValue.value).every((value) => value === true);
});

function changeSortType(type: string) {
  emits('changeSortType', type)
}

function handleSearch() {
  emits('search');
  emits('setIsAllSelected', { windowKey: props.windowKey, isAllSelected: isAllSelected.value });
}

onMounted(() => {
  emits('setIsAllSelected', { windowKey: props.windowKey, isAllSelected: isAllSelected.value });
});
</script>
<template>
  <v-card
    :style="`width: ${props.width}px;`"
  >
    <v-row
      v-if="props.isSortable"
      class="sort-item justify-content-center mt-2"
    >
      <v-card-action
        style="width: 85%"
      >
        <v-btn
          class="w-100"
          :style="`color: ${sortItemColor('ASC')}`"
          @click="changeSortType('ASC')"
        >
          {{ i18n.global.t('pages.cvr_uploads.list.sort.asc') }}
        </v-btn>
      </v-card-action>
    </v-row>
    <v-row
      v-if="props.isSortable"
      class="sort-item justify-content-center"
    >
      <v-card-action
        style="width: 85%"
      >
        <v-btn
          class="w-100"
          :style="`color: ${sortItemColor('DESC')}`"
          @click="changeSortType('DESC')"
        >
          {{ i18n.global.t('pages.cvr_uploads.list.sort.desc') }}
        </v-btn>
      </v-card-action>
    </v-row>
    <v-row
      class="select-action mt-4 mx-auto d-flex justify-content-between"
      style="width: 80%;"
    >
      <v-card-action>
        <v-btn
          style="height: 30px;"
          @click="emits('setSelect', true, props.windowKey)"
        >
          {{ i18n.global.t('pages.common.button.allSelect') }}
        </v-btn>
      </v-card-action>
      <v-card-action
      >
        <v-btn
          class="w-100"
          style="height: 30px;"
          @click="emits('setSelect', false, props.windowKey)"
        >
          {{ i18n.global.t('pages.common.button.clear') }}
        </v-btn>
      </v-card-action>
    </v-row>
    <v-row>
      <v-card-item class="mx-auto" style="width: 98%">
        <slot></slot>
      </v-card-item>
    </v-row>
    <v-row
      class="w-100 d-flex justify-content-center"
    >
      <v-card-item
        class="selectable-items mx-auto pt-0 mb-2"
        style="width: 98%; max-height: 200px; height: 100%;"
      >
        <template v-for="item in (props.items || [])" :key="item?.id">
          <v-checkbox
            v-if="item"
            :label="item[props.candidateLabel]"
            v-model="modelValue[item.id]"
            dencity="compact"
          />
        </template>
      </v-card-item>
    </v-row>
    <v-row
      class="my-2 d-flex justify-content-end"
      style="width: 98%;"
    >
      <v-card-action>
        <v-btn
          class="mr-2"
          @click="emits('close', false)"
        >
          {{ i18n.global.t('pages.common.button.close') }}
        </v-btn>
      </v-card-action>
      <v-card-action
      >
        <v-btn
          class="exec-btn"
          @click="handleSearch"
        >
          {{ i18n.global.t('pages.common.button.conservation') }}
        </v-btn>
      </v-card-action>
    </v-row>
  </v-card>
</template>
<style scoped>
.sort-item .v-btn--variant-elevated,
.sort-item .v-btn--variant-elevated:before,
.select-action .v-btn--variant-elevated,
.select-action .v-btn--variant-elevated:before {
  border-style: none;
  box-shadow: none;
  background-color: none;
}

.selectable-items {
  overflow: auto;
}
</style>